import { EntityTypes, Route } from "./cerebrum-core";
import { FlowEvent } from "./flowEvent/flowEvent";

export class EmulatorDisplay {
  message: string;
  position: Position;
  css: CssClass;
  url?: string;
}

export type Position = 'left' | 'right';
export type CssClass = 'main' | 'responseIn' | 'cancelIn' | 'responseOut' | 'error';

export const DEFAULT_EMULATOR_ROUTE_NAME: string = 'This Flow';
export const DEFAULT_NOT_VALID_EMULATOR_ROUTE_NAME = 'This Flow (Needs to be saved)';
export const DEFAULT_EMULATOR_FLOW_ROUTE: Route | any = {
  name: DEFAULT_EMULATOR_ROUTE_NAME,
  flowName: "",
  start: "start",
  clientId: 0,
  properties: {},
  entityType: "CLIENT",
  entityId: 42
}

export class EmulatorMessage {
  clientId: number;
  id?: number;
  user: string;
  tabId: string;
  flowId?: string;
  entityId?: string;
  entityType?: string;
  message: string;
  sourceId: string;
  messageType: EmulatorMessageType;
  accessToken?: string;
  channelPayload?: {};
  mediaMetaData?: {};
  flowEvent?: FlowEvent;

  sessionId?: string;
  mnoSessionId?: string;
  channelId?: number;
  channelRouteId?: string;
  channelMessageProperties?: any;
}

export type EmulatorMessageType =
  | 'PING'
  | 'PONG'
  | 'MESSAGE'
  | 'MESSAGE_REPLY'
  | 'END'
  | 'START'
  | 'INIT'
  | 'STATUS'
  | 'ERROR'
  | 'RELEASE_SESSION'
  | 'FLOW_EVENT';

export class EmulatorMessageTypes {
  public static readonly PING: EmulatorMessageType = 'PING';
  public static readonly PONG: EmulatorMessageType = 'PONG';
  public static readonly START: EmulatorMessageType = 'START';
  public static readonly END: EmulatorMessageType = 'END';
  public static readonly INIT: EmulatorMessageType = 'INIT';
  public static readonly MESSAGE: EmulatorMessageType = 'MESSAGE';
  public static readonly MESSAGE_REPLY: EmulatorMessageType = 'MESSAGE_REPLY';
  public static readonly ERROR: EmulatorMessageType = 'ERROR';
  public static readonly STATUS: EmulatorMessageType = 'STATUS';
  public static readonly RELEASE_SESSION: EmulatorMessageType = 'RELEASE_SESSION';
  public static readonly FLOW_EVENT: EmulatorMessageType = 'FLOW_EVENT';
}
